var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-map-container sensors_exposure",style:({
    backgroundImage: 'url(' + _vm.hotImgConfig.imgLink + ')',
    height: _vm.imgHeight + 'px',
  }),attrs:{"id":`image-map-container-${_vm.componentConfig.id}`,"sensorsname":"PictureModuleExposure","sensorsdata":JSON.stringify({
      moduleName: `${_vm.componentConfig.sort}|${_vm.componentConfig.type}`,
      contentName: `${_vm.componentConfig.title}`,
    })}})
}
var staticRenderFns = []

export { render, staticRenderFns }